"use strict";

var _defineProperty2 = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactJsonschemaForm = _interopRequireDefault(require("react-jsonschema-form"));
var _reactIntl = require("react-intl");
var _utils = require("../utils");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var CocaFormCell = /*#__PURE__*/function (_react$default$PureCo) {
  function CocaFormCell() {
    var _this;
    _classCallCheck(this, CocaFormCell);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CocaFormCell, [].concat(args));
    _defineProperty(_this, "state", {
      formValues: {
        first_name: '',
        last_name: '',
        email: '',
        gsm: '',
        subsidiary_question: ''
      },
      success: false,
      error: false
    });
    _defineProperty(_this, "stringInput", function (fieldName, label, type) {
      var formValues = _this.state.formValues;
      var cell = _this.props.cell;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group field field-string"
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: "form_".concat(cell.id, "_").concat(fieldName)
      }, label), /*#__PURE__*/_react.default.createElement("input", {
        className: "form-control",
        name: "form_".concat(cell.id, "_").concat(fieldName),
        type: !!type ? type : "text",
        value: formValues[fieldName],
        onChange: function onChange(e) {
          return _this.setState({
            formValues: _objectSpread(_objectSpread({}, formValues), {}, _defineProperty2({}, fieldName, e.target.value))
          });
        }
      }), /*#__PURE__*/_react.default.createElement("span", null));
    });
    _defineProperty(_this, "radioInputs", function (fieldName, choices) {
      var formValues = _this.state.formValues;
      var cell = _this.props.cell;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group field"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "field-radio-group"
      }, choices.map(function (_ref) {
        var fieldValue = _ref.fieldValue,
          label = _ref.label;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "radio",
          key: fieldValue
        }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("input", {
          type: "radio",
          name: "form_".concat(cell.id, "_").concat(fieldName),
          value: fieldValue,
          checked: formValues[fieldName] === fieldValue,
          onChange: function onChange(e) {
            return _this.setState({
              formValues: _objectSpread(_objectSpread({}, formValues), {}, _defineProperty2({}, fieldName, e.currentTarget.value))
            });
          }
        }), /*#__PURE__*/_react.default.createElement("span", null, label))));
      })));
    });
    _defineProperty(_this, "yesNoQuestion", function (fieldName, label, props) {
      var formValues = _this.state.formValues;
      var cell = _this.props.cell;
      return /*#__PURE__*/_react.default.createElement("div", props, /*#__PURE__*/_react.default.createElement("p", null, label), /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group field"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "field-radio-group"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "radio "
      }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("input", {
        type: "radio",
        name: "form_".concat(cell.id, "_").concat(fieldName),
        checked: !!formValues[fieldName],
        onChange: function onChange() {
          return _this.setState({
            formValues: _objectSpread(_objectSpread({}, formValues), {}, _defineProperty2({}, fieldName, true))
          });
        }
      }), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "coca_form.yes.label"
      }))), /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("input", {
        type: "radio",
        name: "form_".concat(cell.id, "_").concat(fieldName),
        checked: formValues[fieldName] !== undefined && !formValues[fieldName],
        onChange: function onChange() {
          return _this.setState({
            formValues: _objectSpread(_objectSpread({}, formValues), {}, _defineProperty2({}, fieldName, false))
          });
        }
      }), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "coca_form.no.label"
      })))))));
    });
    return _this;
  }
  _inherits(CocaFormCell, _react$default$PureCo);
  return _createClass(CocaFormCell, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        formValues = _this$state.formValues,
        success = _this$state.success,
        error = _this$state.error;
      var _this$props = this.props,
        cell = _this$props.cell,
        page = _this$props.page,
        intl = _this$props.intl,
        defaultLanguage = _this$props.defaultLanguage,
        logEvent = _this$props.logEvent,
        width = _this$props.width;
      console.log("formValues:", formValues);
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("style", {
        dangerouslySetInnerHTML: {
          __html: "\n          #form_".concat(cell.id, " {\n            flex: 1;\n          }\n\n          .form_").concat(cell.id, " .field-string {\n            display: flex;\n            width: -webkit-fill-available;\n            align-items: center;\n            height: 1.9em;\n          }\n          .form_").concat(cell.id, " .field-string label {\n            flex: 1;\n            font-weight: bold;\n          }\n          .form_").concat(cell.id, " .field-string input {\n            flex: 2;\n          }\n          .form_").concat(cell.id, " .field-string span {\n            flex: 1;\n          }\n          \n          .form_").concat(cell.id, " .field-radio-group {\n            display: flex;\n          }\n          \n          .form_").concat(cell.id, " > div {\n            left: 0.5em;\n            font-size: ").concat(width / 24, "px;\n            margin-right: 1em;\n          }\n\n          .form_").concat(cell.id, " * {\n            font-family: \"").concat(cell.font, "\";\n            font-size: 0.9em;\n          }\n          \n          .form_").concat(cell.id, " label,\n          .form_").concat(cell.id, " p {\n            color: ").concat(cell.border_color, ";\n          }\n\n          .form_").concat(cell.id, " input[type=text],\n          .form_").concat(cell.id, " input[type=number],\n          .form_").concat(cell.id, " input[type=email] {\n            background-color: ").concat(cell.input_background_color, ";\n            color: ").concat(cell.input_text_color, ";\n            padding: 0.3em;\n            border: 2px solid ").concat(cell.border_color, ";\n            border-radius: 0.5em;\n            width: -webkit-fill-available;\n          }\n          \n          .form_").concat(cell.id, " input[type=text],\n          .form_").concat(cell.id, " input[type=number],\n          .form_").concat(cell.id, " input[type=email] {\n            background-color: ").concat(cell.input_background_color, ";\n            color: ").concat(cell.input_text_color, ";\n            padding: 0.3em;\n            border: 2px solid ").concat(cell.border_color, ";\n            border-radius: 0.5em;\n            width: -webkit-fill-available;\n          }\n\n          .form_").concat(cell.id, " .btn-info {\n            color: ").concat(cell.submit_text_color, ";\n            border: 2px solid ").concat(cell.border_color, ";\n            background-color: ").concat(cell.submit_background_color, ";\n            font-size: 0.8em;\n          }\n\n          .form_").concat(cell.id, " .tsku-confirmation-msg {\n            color: ").concat(cell.confirmation_text_color, ";\n          }\n\n          .form_").concat(cell.id, " .tsku-error-msg {\n            color: ").concat(cell.error_text_color, ";\n          }\n          \n          .form_").concat(cell.id, " .tsku-question {\n            margin-bottom: 0.5em;\n            font-weight: bold;\n          }\n          \n          .form_").concat(cell.id, " .tsku-question-group {\n            margin-bottom: 1.8em;\n          }\n          \n          .form_").concat(cell.id, " .tsku-legal_yes_no {\n            font-size: 0.7em;\n          }\n          \n          .form_").concat(cell.id, " .radio span {\n            font-size: 1.15em;\n          }\n\n          .form_").concat(cell.id, " input.txt_input {\n            width: 43%;\n          }\n          \n          .form_").concat(cell.id, " .tsku-footnote {\n            font-size: 0.7em;\n          }\n          \n          .form_").concat(cell.id, ".tsku-form .tsku-form-bottom {\n            padding-top: 0;\n          }\n\n          .form_").concat(cell.id, ".tsku-form .tsku-form-bottom .btn-info {\n            font-size: 0.7em;\n            font-weight: bold;\n            padding-top: 0.3em;\n            padding-bottom: 0.3em;\n          }\n        ")
        }
      }), /*#__PURE__*/_react.default.createElement("form", {
        className: "form_".concat(cell.id, " tsku-form"),
        autoComplete: "off",
        onSubmit: function onSubmit(e) {
          e.preventDefault();
          if (!formValues.first_name || !formValues.last_name || !formValues.email || !formValues.gsm || !formValues.subsidiary_question || !formValues.brugal_country || formValues.partner_newsletter === undefined || formValues.accepted_tos === undefined || formValues.private_data_acceptation_coca === undefined || formValues.private_data_acceptation_partners === undefined) {
            _this2.setState({
              success: false,
              error: true
            });
          } else {
            var data = _objectSpread({
              cellId: cell.id,
              pageId: page.id,
              languageCode: intl.locale
            }, formValues);
            logEvent("coca_form", data);
            _this2.setState({
              success: true,
              error: false
            });
          }
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group field field-object"
      }, /*#__PURE__*/_react.default.createElement("fieldset", {
        id: "form_".concat(cell.id)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "tsku-question-group"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "tsku-question"
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "coca_form.brugal_country.label"
      })), this.radioInputs('brugal_country', [{
        fieldValue: 'italy',
        label: intl.formatMessage({
          id: 'coca_form.brugal_country.italy.label'
        })
      }, {
        fieldValue: 'spain',
        label: intl.formatMessage({
          id: 'coca_form.brugal_country.spain.label'
        })
      }, {
        fieldValue: 'dominican_republic',
        label: intl.formatMessage({
          id: 'coca_form.brugal_country.dominican_republic.label'
        })
      }])), /*#__PURE__*/_react.default.createElement("div", {
        className: "tsku-question-group"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "tsku-question"
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "coca_form.subsidiary_question.label"
      })), /*#__PURE__*/_react.default.createElement("input", {
        className: "form-control txt_input",
        name: "form_".concat(cell.id, "_subsidiary_question"),
        type: "text",
        value: formValues.subsidiary_question,
        onChange: function onChange(e) {
          return _this2.setState({
            formValues: _objectSpread(_objectSpread({}, formValues), {}, {
              subsidiary_question: e.target.value
            })
          });
        }
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "tsku-question-group"
      }, this.stringInput('last_name', intl.formatMessage({
        id: 'coca_form.last_name.label'
      })), this.stringInput('first_name', intl.formatMessage({
        id: 'coca_form.first_name.label'
      })), this.stringInput('email', intl.formatMessage({
        id: 'coca_form.email.label'
      }), 'email'), this.stringInput('gsm', intl.formatMessage({
        id: 'coca_form.gsm.label'
      }), 'number'), /*#__PURE__*/_react.default.createElement("p", {
        className: "tsku-footnote"
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "coca_form.mandatory_fields.label"
      }))), this.yesNoQuestion('partner_newsletter', intl.formatMessage({
        id: 'coca_form.partner_newsletter.label'
      }), {
        className: "tsku-question-group tsku-legal_yes_no"
      }), this.yesNoQuestion('accepted_tos', intl.formatMessage({
        id: 'coca_form.accepted_tos.label'
      }), {
        className: "tsku-question-group tsku-legal_yes_no"
      }), this.yesNoQuestion('private_data_acceptation_coca', intl.formatMessage({
        id: 'coca_form.private_data_acceptation_coca.label'
      }), {
        className: "tsku-question-group tsku-legal_yes_no"
      }), this.yesNoQuestion('private_data_acceptation_partners', intl.formatMessage({
        id: 'coca_form.private_data_acceptation_partners.label'
      }), {
        className: "tsku-question-group tsku-legal_yes_no"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: 'tsku-form-bottom'
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: 'btn btn-info'
      }, (0, _utils.i18nData)(cell, "submit_button_text", intl, defaultLanguage)), !!success && /*#__PURE__*/_react.default.createElement("span", {
        className: 'tsku-confirmation-msg'
      }, (0, _utils.i18nData)(cell, "confirmation_text", intl, defaultLanguage)), !!error && /*#__PURE__*/_react.default.createElement("span", {
        className: 'tsku-error-msg'
      }, (0, _utils.i18nData)(cell, "error_text", intl, defaultLanguage)))));
    }
  }]);
}(_react.default.PureComponent);
_defineProperty(CocaFormCell, "whyDidYouRender", true);
var _default = exports.default = (0, _reactIntl.injectIntl)(CocaFormCell);